import React from 'react';
import { combineReducers } from 'redux';
import { Route, Switch } from 'react-router-dom';
import { connectRouter } from 'connected-react-router';
import { ReduxAppCreator } from 'UI-Dash-Commons-UI';
import * as mediationDocs from './modules/MediationDocs';
import * as FAQ from './modules/FAQ';
import * as dspDocs from './modules/DspDocs';
import AppHistory from './utils/AppHistory';

const reducer = combineReducers( {
    [ mediationDocs.constants.STATE_MEDIATION_DOCS ]: mediationDocs.reducer,
    [ dspDocs.constants.STATE_DSP_DOCS ]: dspDocs.reducer,
    router: connectRouter( AppHistory )
} );

ReduxAppCreator.createApp( 'Docs', reducer,
    <Switch>
        <Route path={`${mediationDocs.constants.MEDIATION_DOCS_CLIENT_BASE_URL}`}
               component={mediationDocs.MediationDocsContainer}
        />
        <Route path={`${FAQ.constants.FAQ_BASE_URL}`}
               component={FAQ.FAQComponent}
        />
        <Route path={`${dspDocs.constants.DSP_DOCS_CLIENT_BASE_URL}`}
               component={dspDocs.DspDocsContainers}
        />
    </Switch>,
    { appHistory: AppHistory }
);
